<mat-card>
  <app-card-header
    title="Modo Estacionado"
    [subtitle]="dialogData.activo?.identificacion"
    icono="local_parking"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        @if (!form?.value?.activa) {
          <app-info-banner
            [icon]="'info'"
            [title]="'¿Cómo funciona el modo estacionado?'"
            [message]="
              '<strong>Al iniciar:</strong> Se registra la ubicación actual del vehículo.<br><br>
              <strong>Durante el modo:</strong> Si el vehículo se mueve más de <strong>la distancia configurada</strong> de la ubicación registrada, se generará automáticamente un evento de alerta.<br><br>
              <strong>Finalización:</strong> El modo se desactiva automáticamente al detectar movimiento, o puede desactivarse manualmente en cualquier momento.'
            "
            [color]="'blue'"
            [margin]="'0 0 20px 0'"
          ></app-info-banner>
        } @else {
          <app-info-banner
            [icon]="'location_on'"
            [title]="'Modo estacionado activo'"
            [message]="
              '<strong>Estado:</strong> El vehículo está siendo monitoreado.<br><br>
              Se generará una alerta si se detecta un movimiento mayor al configurado de la ubicación registrada.<br><br>
              Puede desactivar el modo manualmente si es necesario.'
            "
            [color]="'green'"
            [margin]="'0 0 20px 0'"
          ></app-info-banner>
        }

        <!-- Sección de Configuración -->
        <app-content-card title="Configuración" icon="settings">
          <mat-form-field [formGroup]="estacionadoForm" style="width: 100%">
            <mat-label>Distancia de aviso (metros)</mat-label>
            <input matInput formControlName="distanciaDeAviso" type="number" />
            <mat-icon matSuffix>straighten</mat-icon>
          </mat-form-field>
        </app-content-card>

        <!-- Sección de Usuarios -->
        <app-content-card title="Usuarios a notificar" icon="people">
          <ng-select
            [items]="usuarios"
            placeholder="Seleccioná los usuarios a notificar"
            loadingText="Cargando..."
            typeToSearchText="Buscar..."
            notFoundText="No se encontraron resultados"
            formControlName="idsUsuarios"
            [multiple]="true"
            [searchFn]="searchUsuario"
            [appendTo]="'body'"
            [closeOnSelect]="false"
            [bindValue]="'_id'"
          >
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.usuario }}</span>
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <div style="padding-bottom: 5px">
                <span>{{ item.usuario }}</span>
                <span style="font-size: 0.7em">
                  ({{ item.datosPersonales?.telefono }})
                </span>
              </div>
            </ng-template>
          </ng-select>
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
        <button
          [irxBoton]="form?.value?.activa ? 'peligro' : 'principal'"
          [disabled]="!this.form.valid || loading"
          type="submit"
        >
          <mat-icon>{{ form?.value?.activa ? 'stop' : 'play_arrow' }}</mat-icon>
          {{ form?.value?.activa ? 'Desactivar' : 'Activar' }} Modo
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
